import Vue from 'vue'

Vue.filter('dinero', value => '$ '+Number(parseFloat(value).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
Vue.filter('doble', value => Number(parseFloat(value).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2}));
Vue.filter('numero', value => Number(value));

Vue.filter('date', value => function() {
     var d = new Date(value);
      d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear();
});




// WEBPACK FOOTER //
// ./src/components/filters.js


// WEBPACK FOOTER //
// ./src/components/filters.js